/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseCancelBillCreateRespVo
 */
export interface PurchaseCancelBillCreateRespVo {
    /**
     * 代买取消手续费账单(billType=2)ID；手续费为0时账单已自动已支付并逻辑删除，ID仍返回
     * @type {number}
     * @memberof PurchaseCancelBillCreateRespVo
     */
    cancelFeeBillId?: number;
    /**
     * 代买取消退款账单(billType=20)ID；未支付阶段仅生成手续费账单，此字段为null
     * @type {number}
     * @memberof PurchaseCancelBillCreateRespVo
     */
    refundBillId?: number;
    /**
     * 代买取消分单后的新订单ID，仅部分取消发生分单时有值，全部取消为null
     * @type {number}
     * @memberof PurchaseCancelBillCreateRespVo
     */
    splitPurchaseCancelID?: number;
}

/**
 * Check if a given object implements the PurchaseCancelBillCreateRespVo interface.
 */
export function instanceOfPurchaseCancelBillCreateRespVo(value: object): value is PurchaseCancelBillCreateRespVo {
    return true;
}

export function PurchaseCancelBillCreateRespVoFromJSON(json: any): PurchaseCancelBillCreateRespVo {
    return PurchaseCancelBillCreateRespVoFromJSONTyped(json, false);
}

export function PurchaseCancelBillCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCancelBillCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'cancelFeeBillId': json['cancelFeeBillId'] == null ? undefined : json['cancelFeeBillId'],
        'refundBillId': json['refundBillId'] == null ? undefined : json['refundBillId'],
        'splitPurchaseCancelID': json['splitPurchaseCancelID'] == null ? undefined : json['splitPurchaseCancelID'],
    };
}

export function PurchaseCancelBillCreateRespVoToJSON(json: any): PurchaseCancelBillCreateRespVo {
    return PurchaseCancelBillCreateRespVoToJSONTyped(json, false);
}

export function PurchaseCancelBillCreateRespVoToJSONTyped(value?: PurchaseCancelBillCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cancelFeeBillId': value['cancelFeeBillId'],
        'refundBillId': value['refundBillId'],
        'splitPurchaseCancelID': value['splitPurchaseCancelID'],
    };
}

